import request from '@/utils/request'
import requestSpi from '@/utils/request-spi'
const kangzhongApi = {
  // 绑定修理厂查询
  queryBind: (params) => {
    return request({
      url: '/public/query-bind/token',
      method: 'get',
      params
    })
  },
  // 判断绑定修理厂
  getBindClientInfo: (params) => {
    return request({
      url: '/public/bind-client/info',
      method: 'get',
      params
    })
  },
  // 绑定修理厂
  bindExternal: (data) => {
    return request({
      url: '/public/external-bind',
      method: 'post',
      data
    })
  },
  // 外部登录
  entryValidate: (params) => {
    return request({
      url: '/public/entry-point/validate',
      method: 'get',
      params
    })
  },
  // 登录验证信息查询
  externalLogin: (params) => {
    return request({
      url: '/public/external/login',
      method: 'get',
      params
    })
  },
  // 获取验证码
  getVerifyCode: (params) => {
    return request({
      url: '/public/external/binding-verifyCode',
      method: 'get',
      params
    })
  },
  // 用户查询接口
  queryUser: (params) => {
    return request({
      url: '/public/query-user/userMobile',
      method: 'get',
      params
    })
  },
  // 绑定验证码获取接口
  verifyBossMobile: (params) => {
    return request({
      url: '/public/boss-verifyCode/userMobile',
      method: 'get',
      params
    })
  }
}
const externalLoginApi = {
  // 用户自动登录请求
  externalLogin: (data, headers) => {
    return requestSpi({
      url: '/external/user/request-login',
      method: 'post',
      headers: {
        'Extra-App-Code': headers.code,
        'Extra-Timestamp': headers.timestamp,
        'Extra-Signature': headers.signature
      },
      data
    })
  }
}
export { kangzhongApi, externalLoginApi }
